import RpcService       from '@/core/services/Rpc/RpcService';
import type RpcResponse from '@/core/services/Rpc/RpcResponse';

class BookmarksDAO {

    static async add(productCategoryId: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('bookmarks.add', { productCategoryId });
    }

    static async delete(productCategoryId: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('bookmarks.delete', { productCategoryId });
    }
}

export default BookmarksDAO;
